var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[(_vm.firstRun())?_c('GetStarted'):_c('UserTabs')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }